export default __webpack_public_path__ + "static/media/Forms-amico.f15b3b27.svg";